import T from "ant-design-vue/es/table/Table";
export default {
	data() {
		return {
			selectedRows: [],
			selectedRowKeys: [],
			localDataSource: [], //表格数据
			localLoading: false, //加载状态
			localPagination: Object.assign({}, this.pagination) //分页数据参数，合并T中的pagination
		};
	},
	props: Object.assign({}, T.props, {
		rowKey: {
			//唯一标识
			type: [String, Function],
			default: "id"
		},
		isAuto: {
			type: Boolean, //是否自动获取数据
			default: true
		},
		data: {
			type: Function //数据源 promis对象
			// required: true
		},
		pageNum: {
			//页码
			type: Number,
			default: 1
		},
		pageSize: {
			//每页条数
			type: Number,
			default: 10
		},
		showSizeChanger: {
			//是否可以改变 pageSize
			type: Boolean,
			default: true
		},
		size: {
			//当为「small」时，是小尺寸分页
			type: String,
			default: "default"
		},
		alert: {
			//提示信息
			type: [Object, Boolean],
			default: null
		},
		rowSelection: {
			//列表项是否可选择相关配置
			type: Object,
			default: null
		},
		showPagination: {
			//分页器
			type: String | Boolean,
			default: "auto"
		}
	}),
	watch: {
		pageNum(val) {
			Object.assign(this.localPagination, {
				current: val
			});
		},
		pageSize(val) {
			Object.assign(this.localPagination, {
				pageSize: val
			});
		},
		showSizeChanger(val) {
			Object.assign(this.localPagination, {
				showSizeChanger: val
			});
		}
	},
	created() {
		//封装分页参数
		if (["auto", true].includes(this.showPagination)) {
			this.localPagination = Object.assign({}, this.localPagination, {
				current: this.pageNum,
				pageSize: this.pageSize,
				showSizeChanger: this.showSizeChanger,
				showTotal: total => `共${total}条`
			});
		} else {
			//不显示分页
			this.localPagination = false;
		}
		if (this.isAuto) {
			//加载数据
			this.loadData();
		}
	},
	methods: {
		/**
		 * 表格重新加载方法
		 * 如果参数为 true, 则强制刷新到第一页
		 */
		refresh(bool = false) {
			if (bool) {
				this.localPagination = Object.assign({}, {
					current: 1,
					pageSize: this.pageSize
				});
			}
			this.loadData();
		},
		/**
		 * 加载数据方法
		 * @param {Object} pagination  分页选项器
		 * @param {Object} filters 过滤条件
		 * @param {Object} sorter 排序条件
		 */
		loadData(pagination, filters, sorter) {
			this.localLoading = true;
			const parameter = {};
			//(pagination && pagination.current) || (this.showPagination && this.localPagination.current) || this.pageNum,
			if (pagination) {
				parameter.pageNum = pagination.current;
				parameter.firstResult = (pagination.current - 1) * pagination.pageSize;
				parameter.pageSize = pagination.pageSize;
			} else if (this.showPagination) {
				parameter.pageNum = this.localPagination.current;
				parameter.firstResult =
					(this.localPagination.current - 1) * this.localPagination.pageSize;
				parameter.pageSize = this.localPagination.pageSize;
			} else {
				parameter.pageNum = this.pageNum;
				parameter.firstResult = (this.pageNum - 1) * this.pageSize;
				parameter.pageSize = this.pageSize;
			}
			//排序
			if (sorter && sorter.field) {
				parameter.sortField = sorter.field;
			}
			//过滤条件
			Object.assign(parameter, filters);
			// console.log("loadData条件", parameter);
			// this.data是外层传入的pomise对象
			const result = this.data(parameter);
			if (
				(typeof result === "object" || typeof result === "function") &&
				typeof result.then === "function"
			) {
				//方法返回
				result.then(res => {
					// console.log(res);
					if (this.showPagination) {
						const paging = {};
						paging.current = res.pageNo;
						paging.total = res.totalRows;
						paging.showSizeChanger = this.showSizeChanger;
						if (pagination) {
							paging.pageSize = pagination.pageSize;
						} else {
							paging.pageSize = this.localPagination.pageSize;
						}
						this.localPagination = Object.assign({},
							this.localPagination,
							paging
						);
						// console.log(this.localPagination);
					} else {
						this.localPagination = false;
					}

					// 为防止删除数据后导致页面当前页面数据长度为 0 ,自动翻页到上一页
					if (
						res.datas.length === 0 &&
						this.showPagination &&
						this.localPagination.current > 1
					) {
						this.localPagination.current--;
						this.loadData();
						return;
					}

					// 这里用于判断接口是否有返回 r.totalRows 且 this.showPagination = true
					// 且 pageNo 和 pageSize 存在 且 totalCount 小于等于 pageNo * pageSize 的大小
					// 当情况满足时，表示数据不满足分页大小，关闭 table 分页功能
					try {
						if (
							["auto", true].includes(this.showPagination) &&
							res.totalRows <= res.pageNo * this.localPagination.pageSize
						) {
							//只有一页时是否隐藏分页器
							this.localPagination.hideOnSinglePage = true;
						}
					} catch (e) {
						this.localPagination = false;
					}
					this.localDataSource = res.datas; // 返回结果中的数组数据
					this.localLoading = false;
				});
			}
		},
		/**
		 * 用于更新已选中的列表数据
		 * @param {Object} selectedRowKeys
		 * @param {Object} selectedRows
		 */
		updateSelect(selectedRowKeys, selectedRows) {
			this.selectedRows = selectedRows;
			this.selectedRowKeys = selectedRowKeys;
		},
		/**
		 * 清空 table 已选中项
		 */
		clearSelected() {
			if (this.rowSelection) {
				this.selectedRowKeys = [];
				this.selectedRows = [];
				this.rowSelection.onChange([], []);
			}
		}
	},
	render() {
		const props = {};
		const localKeys = Object.keys(this.$data);
		Object.keys(T.props).forEach(k => {
			const localKey = `local${k.substring(0, 1).toUpperCase()}${k.substring(
        1
      )}`;
			if (localKeys.includes(localKey)) {
				props[k] = this[localKey];
				return props[k];
			}
			if (k === "rowSelection") {
				if (this.rowSelection) {
					// 如果需要使用alert，则重新绑定 rowSelection 事件
					// console.log("this.rowSelection", this.rowSelection);
					props[k] = {
						...this.rowSelection,
						selectedRows: this.selectedRows,
						selectedRowKeys: this.selectedRowKeys,
						onChange: (selectedRowKeys, selectedRows) => {
							this.updateSelect(selectedRowKeys, selectedRows);
							typeof this[k].onChange !== "undefined" &&
								this[k].onChange(selectedRowKeys, selectedRows);
						}
					};
					return props[k];
				} else if (!this.rowSelection) {
					// 如果没打算开启 rowSelection 则清空默认的选择项
					props[k] = null;
					return props[k];
				}
			}
			this[k] && (props[k] = this[k]);
			return props[k];
		});
		const table = ( <
			a-table { ...{
					props,
					scopedSlots: { ...this.$scopedSlots
					}
				}
			}
			onChange = {
				this.loadData
			}
			onExpand = {
				(expanded, record) => {
					this.$emit("expand", expanded, record);
				}
			} > {
				Object.keys(this.$slots).map(name => ( <
					template slot = {
						name
					} > {
						this.$slots[name]
					} < /template>
				))
			} <
			/a-table>
		);

		return <div class = "table-wrapper" > {
			table
		} < /div>;
	}
};
